export default __webpack_public_path__ + "static/media/BetRefund-Notification.4fe4e4f9.svg";